import { useEffect } from 'react';

const DEFAULT_TITLE = 'Pliable';
const DEFAULT_FAVICON = '/favicon/favicon-32x32.png';

/**
 * Apply whitelabel branding to document title and favicon.
 * Restores defaults on unmount.
 */
export function usePageBranding(branding: { page_title?: string | null; favicon_path?: string | null } | undefined) {
  useEffect(() => {
    const title = branding?.page_title || DEFAULT_TITLE;
    const favicon = branding?.favicon_path || DEFAULT_FAVICON;

    document.title = title;
    const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"][sizes="32x32"]');
    if (faviconLink) {
      faviconLink.href = favicon;
    }

    return () => {
      document.title = DEFAULT_TITLE;
      if (faviconLink) {
        faviconLink.href = DEFAULT_FAVICON;
      }
    };
  }, [branding?.page_title, branding?.favicon_path]);
}
